import { createAction } from 'redux-act';

const actionsFactory = (path = '') => (actionType, payloadReducer, metaReducer = (...args) => ({ args })) =>
  createAction(path + actionType, payloadReducer, metaReducer);

export default actionsFactory;
